import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';
import CustomBtn from '../../generic/CustomBtn';
import { appStore } from '../../state/app';
import storage from '../../utils/storage';
import { checkingLogin } from '../../utils/login';

const ErrorBoundaries = () => {
  const { state, update } = useContext(appStore);
  const { app: { errors }, wallet } = state;
  const history = useHistory();
  const translate = useIntl();

  const handleRelogin = async () => {
    update('app.errors', '');
    storage.del('token');
    history.push('/login');
    const signedOut = await wallet.signOut();
    if (!signedOut) return;
    storage.set('isSignIn', true);
    const connected = await wallet.signIn({ forceConnect: true, withLoginMessage: true });
    if (!connected) {
      storage.del('isSignIn');
      return;
    }
    const selectedAccount = await wallet.account();
    if (selectedAccount?.accountId) {
      await checkingLogin(selectedAccount, history, () => {}, false, update);
    }
  };

  useEffect(() => {
    document.body.classList.add('no-scroll');
    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, []);

  const btnPoppup = () => {
    if (errors.type === 1) {
      return (

        <CustomBtn
          label={translate.formatMessage({ id: 'errorBoundaries.register' })}
          handleClick={() => {
            update('app.errors', '');
            history.push('welcome');
          }}
          customClass="modal_btn_item green"
        />
      );
    }

    if (errors.type === 2) {
      return (
        <>
          <CustomBtn
            label={translate.formatMessage({ id: 'errorBoundaries.refreshPage' })}
            handleClick={() => {
              window.location.reload();
            }}
            customClass="modal_btn_item green"
          />
          <span className="error-modal__or">{translate.formatMessage({ id: 'errorBoundaries.or' })}</span>
          <CustomBtn
            label={translate.formatMessage({ id: 'errorBoundaries.re-login' })}
            handleClick={() => {
              handleRelogin();
            }}
            customClass="modal_btn_item green"
          />
        </>
      );
    }

    return (
      <CustomBtn
        label={translate.formatMessage({ id: 'errorBoundaries.re-login' })}
        handleClick={() => {
          handleRelogin();
        }}
        customClass="modal_btn_item green"
      />
    );
  };

  return (
    <div className="error-modal custom">
      <div className="error-modal__bg" />
      <div className="error-modal__wrap">
        <p className="error-modal__text">{errors.text}</p>
        <div className="error-modal__btn">
          {btnPoppup()}
        </div>
      </div>
    </div>
  );
};

export default ErrorBoundaries;
